import { render } from "./MyStepWizard.vue?vue&type=template&id=c60a112a&scoped=true"
import script from "./MyStepWizard.vue?vue&type=script&lang=js"
export * from "./MyStepWizard.vue?vue&type=script&lang=js"

import "./MyStepWizard.vue?vue&type=style&index=0&id=c60a112a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c60a112a"]])

export default __exports__